import _defineProperty from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { vgField } from '../../channeldef';
import { fieldExpr } from '../../timeunit';
import { duplicate, hash as _hash, keys, vals } from '../../util';
import { DataFlowNode } from './dataflow';
export var TimeUnitNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(TimeUnitNode, _DataFlowNode);

  function TimeUnitNode(parent, formula) {
    var _this;

    _classCallCheck(this, TimeUnitNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimeUnitNode).call(this, parent));
    _this.formula = formula;
    return _this;
  }

  _createClass(TimeUnitNode, [{
    key: "clone",
    value: function clone() {
      return new TimeUnitNode(null, duplicate(this.formula));
    }
  }, {
    key: "merge",

    /**
     * Merge together TimeUnitNodes assigning the children of `other` to `this`
     * and removing `other`.
     */
    value: function merge(other) {
      this.formula = Object.assign({}, this.formula, other.formula);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = other.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;
          other.removeChild(child);
          child.parent = this;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      other.remove();
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(vals(this.formula).map(function (f) {
        return f.as;
      }));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(vals(this.formula).map(function (f) {
        return f.field;
      }));
    }
  }, {
    key: "hash",
    value: function hash() {
      return "TimeUnit ".concat(_hash(this.formula));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return vals(this.formula).map(function (c) {
        return {
          type: 'formula',
          as: c.as,
          expr: fieldExpr(c.timeUnit, c.field)
        };
      });
    }
  }], [{
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var formula = model.reduceFieldDef(function (timeUnitComponent, fieldDef) {
        var timeUnit = fieldDef.timeUnit,
            field = fieldDef.field;

        if (timeUnit) {
          var as = vgField(fieldDef, {
            forAs: true
          });
          var component = {
            as: as,
            timeUnit: timeUnit,
            field: field
          };
          timeUnitComponent[_hash(component)] = component;
        }

        return timeUnitComponent;
      }, {});

      if (keys(formula).length === 0) {
        return null;
      }

      return new TimeUnitNode(parent, formula);
    }
  }, {
    key: "makeFromTransform",
    value: function makeFromTransform(parent, t) {
      var component = Object.assign({}, t);
      return new TimeUnitNode(parent, _defineProperty({}, _hash(component), component));
    }
  }]);

  return TimeUnitNode;
}(DataFlowNode);